<template>
  <b-container>
    <b-card no-body>
      <b-table :items="items" responsive :fields="['created', 'form_id', 'first_name', 'last_name', 'email', 'phone', 'comments']" :show-empty="true" empty-text="None of your forms have been submitted yet.">
        <template v-slot:cell(created)='data'>
          {{data.item.created | date}}
        </template>
      </b-table>
    </b-card>
  </b-container>
</template>

<script>

import { db } from '@/main.js'
import ItemMixin from '@/mixins/Item.js'

export default {
  name: 'form_results',
  props: ['site', 'user', 'profile'],
  mixins: [ItemMixin],
  firestore: function () {
    return {
      items: db.collection('site').doc(this.$route.params.site_id).collection('form_result').orderBy('created', 'desc')
    }
  },
  data() {
    return {
      items: [],
    }
  },
}
</script>

<style scoped>

</style>
